import React from 'react';
import PropTypes from 'prop-types';

export function DesktopBanner({ whitelabel }) {
    return whitelabel === 'blocket' ? (
        <div
            id="index_panorama"
            className="tag panorama inview load"
            data-horseshoe-banner
            data-astbanner-name="index_panorama"
            data-testid="index_panorama"
            aria-hidden="true"
            style={{ minHeight: 240 }}
        />
    ) : (
        <div className="banners" style={{ height: '150px' }} aria-hidden="true">
            <div className="banners__left-skyscraper" aria-hidden="true">
                <div className="banners__sticky-skyscraper">
                    <div id="skyscraperleft_1" data-horseshoe-banner data-astbanner-name="skyscraperleft_1" data-testid="skyscraperleft_1">
                        <div id="skyscraperleft_1-button" className="banners-cogwheel-button" />
                    </div>
                </div>
            </div>
            <div
                id="topboard"
                className="banners__topboard u-text-center"
                style={{ width: 1010, minHeight: 150 }}
                data-horseshoe-banner
                data-astbanner-name="topboard"
                data-testid="topboard"
                aria-hidden="true">
                <div id="topboard-button" className="banners-cogwheel-button" />
            </div>
            <div className="banners__right-skyscraper" aria-hidden="true">
                <div className="banners__sticky-skyscraper">
                    <div
                        id="skyscraperright_1"
                        data-horseshoe-banner
                        data-astbanner-name="skyscraperright_1"
                        data-testid="skyscraperright_1">
                        <div id="skyscraperright_1-button" className="banners-cogwheel-button" />
                    </div>
                </div>
            </div>
            <div
                id="wallpaper"
                className="hidden"
                data-horseshoe-banner
                data-astbanner-name="wallpaper"
                data-testid="wallpaper"
                aria-hidden="true"
            />
        </div>
    );
}

DesktopBanner.propTypes = {
    whitelabel: PropTypes.string,
};
